<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="100px" label-position="right">
      <el-form-item label="分类名称" prop="materialTypeName">
        <el-input v-model="formData.materialTypeName" placeholder="请输入分类名称" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="分类编码" prop="materialTypeCode">
        <el-input v-model="formData.materialTypeCode" placeholder="请输入分类编码" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="上级分类" prop="parentMaterialTypeId">
        <el-select v-model="formData.parentMaterialTypeId" filterable  placeholder="请选择上级分类">
          <el-option
            v-for="item in materialTypeData"
            :key="item.materialTypeId"
            :label="item.materialTypeName"
            :value="item.materialTypeId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="state" v-show = '!formData.materialTypeId'>
        <el-switch  v-model="formData.state" active-value="1" inactive-value="2"></el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'ManageAdd',
  components: {
  },
  data () {
    return {
      formData: {
        materialTypeName: '', // 分类名称
        materialTypeCode: '', // 分类编号
        parentMaterialTypeId: '1', // 上级分类
        state: '1' // 状态1启用2禁用
      },
      materialTypeData: [], // 上级分类
      rules: {
        materialTypeName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ],
        materialTypeCode: [
          { required: true, message: '请输入物料编码', trigger: 'blur' }
        ],
        parentMaterialTypeId: [
          { required: true, message: '请选择上级分类', trigger: 'blur' }
        ],
        state: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    materialTypeId () {
      return this.$route.query.materialTypeId
    }
  },
  watch: {
  },
  created () {
    if (this.materialTypeId) {
      this.formData = this.$route.query
    }
    this.loadMaterialType() // 获取上级分类
  },
  methods: {
    loadMaterialType () {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        // console.log('类型', res)
        this.materialTypeData = res || []
        this.materialTypeData.unshift({
          materialTypeId: '1',
          materialTypeName: '无'
        })
      })
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.materialTypeId ? this.$apis.material.updateYhMaterialType : this.$apis.material.insertYhMaterialType
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
